import { _ as c } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.join-c1bca812.js";
import "./es.date.to-string-6ed49878.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.match-5eb65eed.js";
import "./es.string.small-23219181.js";
import { forwardRef as G } from "react";
import k from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as R } from "./getMetrics-953aa4f8.js";
import "./carousel.js";
import "./index-8b07dec9.js";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./index-5d0f31c6.js";
import { jsx as o } from "react/jsx-runtime";
import "./es.string.trim-6e13db75.js";
import { InputState as U } from "./helperText.js";
import "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import { T as H } from "./index-f5b44da3.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./export-cdcbfb2b.js";
import "./array-method-is-strict-e5a3c878.js";
import "./object-keys-719a5561.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./classof-21a3574e.js";
import "./function-apply-4756dee6.js";
import "./to-string-92a62764.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./string-html-forced-a746405b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./combineRefs-c9ad2c39.js";
import "./useMediaQuery.js";
import "./isApiSupported-66660265.js";
import "./isClient-2f5bedbd.js";
import "./iconButton.js";
import "./button.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./useIsMounted.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./string-trim-14e37ad3.js";
import "./aria.js";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useWindowSize.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./tooltip.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./uniqueId.js";
import "./es.global-this-a7f40ce1.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "@ucl/ucl-translation";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./badge.js";
var J = "Credit/Debit Card Number", V = "1234 1234 1234 1234", F = /.{1,4}/g, X = "[0-9s]{13,19}", f = "2", _ = "5", $ = "4", q = "3", y = "data:image/svg+xml;base64,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", K = "data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyMSI+ICA8ZyBpZD0iUGFnZS0xIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8ZyBpZD0idmlzYSI+ICAgICAgPGcgaWQ9ImNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiPiAgICAgICAgPHBhdGggaWQ9InNoYXBlIiBmaWxsPSIjRjZGOUZDIiBkPSJNMjYuNTggMTlIMi40MkEyLjQgMi40IDAgMCAxIDAgMTYuNjJWMi4zOEEyLjQgMi40IDAgMCAxIDIuNDIgMGgyNC4xNkEyLjQgMi40IDAgMCAxIDI5IDIuMzh2MTQuMjVBMi40IDIuNCAwIDAgMSAyNi41OCAxOXoiLz4gICAgICAgIDxwYXRoIGlkPSJzaGFwZSIgZmlsbD0iI0Y5OUYxQiIgZD0iTTAgMTZ2LjYzQTIuNCAyLjQgMCAwIDAgMi40MiAxOWgyNC4xNkEyLjQgMi40IDAgMCAwIDI5IDE2LjYyVjE2SDB6Ii8+ICAgICAgICA8cGF0aCBpZD0ic2hhcGUiIGZpbGw9IiMyRDQ5OTAiIGQ9Ik0wIDN2LS42M0EyLjQgMi40IDAgMCAxIDIuNDIgMGgyNC4xNkEyLjQgMi40IDAgMCAxIDI5IDIuMzhWM0gwem0xMy45IDMuMTJsLTEuNDggNi43N2gtMS43N2wxLjQ2LTYuNzdoMS43OHptNy40NyA0LjM4bC45NC0yLjU1LjU0IDIuNTVoLTEuNDh6bTEuOTkgMi40SDI1bC0xLjQ0LTYuNzhoLTEuNTFhLjguOCAwIDAgMC0uNzYuNWwtMi42NyA2LjI3aDEuODdsLjM3LTFoMi4yOGwuMjIgMXptLTQuNjQtMi4yMmMwLTEuNzgtMi41MS0xLjg4LTIuNS0yLjY4LjAxLS4yNC4yNS0uNS43Ni0uNTdhMy40IDMuNCAwIDAgMSAxLjc1LjNsLjMxLTEuNDNjLS40Mi0uMTUtLjk3LS4zLTEuNjYtLjMtMS43NiAwLTMgLjkyLTMgMi4yNC0uMDEuOTcuODggMS41MiAxLjU1IDEuODQuNy4zMy45My41NS45My44NC0uMDEuNDYtLjU2LjY2LTEuMDcuNjYtLjkuMDItMS40MS0uMjMtMS44Mi0uNDJsLS4zMyAxLjQ4Yy40Mi4xOSAxLjE5LjM1IDEuOTguMzYgMS44NyAwIDMuMDktLjkgMy4xLTIuMzJ6bS03LjM3LTQuNTZMOC40NyAxMi45SDYuNkw1LjE4IDcuNWMtLjA5LS4zMy0uMTctLjQ1LS40My0uNkE3LjUzIDcuNTMgMCAwIDAgMyA2LjMzbC4wNC0uMmgzLjAzYy4zOCAwIC43My4yNi44Mi43bC43NSAzLjkxIDEuODUtNC42aDEuODZ6Ii8+ICAgICAgPC9nPiAgICA8L2c+ICA8L2c+PC9zdmc+", II = "data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyMSI+ICA8ZyBpZD0iUGFnZS0xIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8ZyBpZD0ibWFzdGVyY2FyZCI+ICAgICAgPGcgaWQ9ImNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiPiAgICAgICAgPHBhdGggaWQ9InNoYXBlIiBmaWxsPSIjMDAzNjYzIiBkPSJNMjYuNTggMTlIMi40MkEyLjQgMi40IDAgMCAxIDAgMTYuNjJWMi4zOEEyLjQgMi40IDAgMCAxIDIuNDIgMGgyNC4xNkEyLjQgMi40IDAgMCAxIDI5IDIuMzh2MTQuMjVBMi40IDIuNCAwIDAgMSAyNi41OCAxOXoiLz4gICAgICAgIDxjaXJjbGUgaWQ9InNoYXBlIiBjeD0iMTAuNSIgY3k9IjkuNSIgcj0iNi41IiBmaWxsPSIjRUIxQzI2Ii8+ICAgICAgICA8Y2lyY2xlIGlkPSJzaGFwZSIgY3g9IjE4LjUiIGN5PSI5LjUiIHI9IjYuNSIgZmlsbD0iI0Y5OUYxQiIvPiAgICAgICAgPHBhdGggaWQ9InNoYXBlIiBmaWxsPSIjRUY1RDIwIiBkPSJNMTQuNSA0LjM4YTYuNDkgNi40OSAwIDAgMCAwIDEwLjI0IDYuNDkgNi40OSAwIDAgMCAwLTEwLjI0eiIvPiAgICAgIDwvZz4gICAgPC9nPiAgPC9nPjwvc3ZnPg==", iI = "data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyMSI+ICA8ZyBpZD0iUGFnZS0xIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8ZyBpZD0iYW1leCI+ICAgICAgPGcgaWQ9ImNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xIDIpIj4gICAgICAgIDxwYXRoIGlkPSJzaGFwZSIgZmlsbD0iIzFEOTFDRSIgZD0iTTI3LjU4IDE5SDMuNDJBMi40IDIuNCAwIDAgMSAxIDE2LjYyVjIuMzhBMi40IDIuNCAwIDAgMSAzLjQyIDBoMjQuMTZBMi40IDIuNCAwIDAgMSAzMCAyLjM4djE0LjI1QTIuNCAyLjQgMCAwIDEgMjcuNTggMTl6Ii8+ICAgICAgICA8cG9seWxpbmUgaWQ9InNoYXBlIiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjUuMDYzIDExLjg5NiA0LjU5MSAxMyAuMzYgMTMgMy42OTkgNiAxMS42NzQgNiAxMi40NzkgNy41NDYgMTMuMjMxIDYgMTYuMDY0IDYgMTcuNDkyIDYgMjMuOTgzIDYgMjQuOTAyIDYuOTYxIDI1Ljg4OSA2IDMwLjg4MiA2IDI3LjMzNyA5LjQ5MiAzMC43MjkgMTMgMjUuODk3IDEzIDI0LjgxNiAxMS45NjkgMjMuNzQ0IDEzIDE3LjQ5MiAxMyAxNi4wNjQgMTMgNi40OTYgMTMgNS45NzcgMTEuODk2Ii8+ICAgICAgICA8cGF0aCBpZD0ic2hhcGUiIGZpbGw9IiMxRDkxQ0UiIGQ9Ik01Ljk4IDExLjk3aC0uOTIuOTJ6TTE2LjIgN2gtMi4xbC0xLjU4IDMuMzVMMTAuODIgN2gtMi4xdjQuODVMNi41NSA3SDQuNThsLTIuMzIgNWgxLjQybC40Ny0xLjE0aDIuN0w3LjM5IDEySDEwVjcuOTNMMTEuODUgMTJoMS4yMmwxLjg0LTR2NGgxLjI5Vjd6bTguNjcgMS42MkwyMy4zNyA3aC02LjAydjVIMjMuMTdsMS42NS0xLjY0TDI2LjQ4IDEyaDEuNTVsLTIuMzctMi41M0wyOC4xIDdoLTEuNjJsLTEuNjEgMS42MnpNMjEuNyAxMWgtMy4wNlY5LjloMy4wNlY4LjloLTMuMDZWOGgzLjA2di0uODVsMi4yNyAyLjI3LTIuMjcgMi4yOFYxMXpNNS41MyA3LjgybC44OCAyLjAzSDQuNThsLjk1LTIuMDN6Ii8+ICAgICAgPC9nPiAgICA8L2c+ICA8L2c+PC9zdmc+", tI = ["$textSize"], MI = ["iconAlignment", "textSize", "value", "onBlur", "onChange", "pattern", "autoComplete", "maxLength", "minLength", "placeholder", "required", "labelProp", "infoProp", "trailingText", "helperTextProp", "inputState"], gI = /* @__PURE__ */ k.div.withConfig({
  displayName: "creditCardInput__Wrapper",
  componentId: "sc-1dvykkz-0"
})(["", " && input{width:", ";}&& input:not([disabled])::placeholder{color:", ";}&& input:disabled::placeholder{color:", ";}"], function(I) {
  var i = I.$textSize, t = c(I, tI);
  return i === "small" ? `
        --svg-wrapper-width-global: ` + t.theme.components.creditCardInput.Wrapper["--svg-wrapper-width-global"].small + `;
        --svg-wrapper-height-global: ` + t.theme.components.creditCardInput.Wrapper["--svg-wrapper-height-global"].small + `;
      ` : `
        --svg-wrapper-width-global: ` + t.theme.components.creditCardInput.Wrapper["--svg-wrapper-width-global"].default + `;
        --svg-wrapper-height-global:  ` + t.theme.components.creditCardInput.Wrapper["--svg-wrapper-height-global"].default + `;
      `;
}, function(I) {
  return I.theme.components.creditCardInput.Wrapper.input.width;
}, function(I) {
  return I.theme.components.creditCardInput.Wrapper.inputNotDisabledPlaceholder.color;
}, function(I) {
  return I.theme.components.creditCardInput.Wrapper.inputDisabledPlaceholder.color;
}), rI = function(i) {
  if (!i)
    return i;
  var t = i.match(F);
  return t == null ? void 0 : t.join(" ");
}, M = y, T = function(i) {
  if (i && i.length > 0) {
    var t = i[0];
    switch (t) {
      case f:
      case _:
        M = II;
        return;
      case $:
        M = K;
        return;
      case q:
        M = iI;
        return;
    }
  }
  M = y;
}, d = function() {
  var i = /* @__PURE__ */ o("img", {
    alt: "Credit card image",
    src: M
  });
  return i;
}, ut = /* @__PURE__ */ G(function(I, i) {
  var t = I.iconAlignment, N = t === void 0 ? "right" : t, A = I.textSize, m = A === void 0 ? "medium" : A, e = I.value, g = e === void 0 ? "" : e, x = I.onBlur, p = I.onChange, D = I.pattern, S = D === void 0 ? X : D, a = I.autoComplete, z = a === void 0 ? "cc-number" : a, C = I.maxLength, s = C === void 0 ? 23 : C, u = I.minLength, E = u === void 0 ? 14 : u, j = I.placeholder, w = j === void 0 ? V : j, b = I.required, P = I.labelProp, Q = I.infoProp, Z = I.trailingText, O = I.helperTextProp, n = I.inputState, h = n === void 0 ? U.NONE : n, Y = c(I, MI), v = R({
    label: "CreditCardInput"
  });
  T(g == null ? void 0 : g.toString());
  var W = function(r) {
    var L, l = r.target.value.replace(/\D/g, "");
    T(l);
    var B = (L = rI(l)) != null ? L : "";
    r.target.value = B, p && p(r);
  };
  return /* @__PURE__ */ o(gI, Object.assign({
    $textSize: m
  }, v, {
    children: /* @__PURE__ */ o(H, Object.assign({
      value: g == null ? void 0 : g.toString(),
      type: "tel",
      inputMode: "numeric",
      pattern: S,
      autoComplete: z,
      maxLength: s,
      minLength: E,
      placeholder: w,
      textSize: m,
      required: b,
      endAdornmentProp: {
        endAdornment: N === "right" ? d() : void 0
      },
      startAdornmentProp: {
        startAdornment: N === "left" ? d() : void 0
      },
      onChange: W,
      onBlur: x,
      ref: i,
      labelProp: Object.assign({
        label: J
      }, P),
      infoProp: Object.assign({}, Q),
      trailingText: Z,
      inputState: h,
      helperTextProp: O
    }, Y))
  }));
});
export {
  ut as CreditCardInput
};
